import { render, staticRenderFns } from "./veStuCheckModifyEdit.vue?vue&type=template&id=24919e1f&scoped=true"
import script from "./veStuCheckModifyEdit.vue?vue&type=script&lang=js"
export * from "./veStuCheckModifyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24919e1f",
  null
  
)

export default component.exports